<template>
  <div class="mt-5" v-if="products.length">
    <h2>Legg till dato</h2>
    <p>
      Velg opplevelse, oppgi antall deltakere, start og slutt-tid, bookingfrist, samt tilgjengelig
      dato. Trykk så på Lagre dato.
    </p>
    <div class="d-flex justify-content-between">
      <b-button :to="{ name: 'bookings' }" variant="secondary" size="sm" class="mb-2">
        Tilbake
      </b-button>
    </div>
    <b-card no-body>
      <b-tabs pills card vertical nav-wrapper-class="w-30">
        <b-tab
          v-for="variation in activeVariations"
          :key="variation.id"
          :title="`${variation.variation_name}`"
          active
        >
          <b-card-text>
            <add-dates-to-product :variation="variation" />
          </b-card-text>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AddDatesToProduct from '@/components/booking/AddDatesToProduct.vue';

export default {
  components: {
    AddDatesToProduct,
  },
  mounted() {
    if (this.products.length === 0) {
      this.getProducts();
    }
  },
  computed: {
    ...mapGetters({
      products: 'products/activeProducts',
      user: 'auth/getUser'
    }),
    activeVariations() {
      return this.user.supplier.variations
    }
  },
  methods: {
    ...mapActions({
      getProducts: 'products/getProducts',
    }),
  },
};
</script>

<style>
</style>
